import { render, staticRenderFns } from "./RangeColorLegend.vue?vue&type=template&id=202627f7&scoped=true"
import script from "./RangeColorLegend.vue?vue&type=script&lang=js"
export * from "./RangeColorLegend.vue?vue&type=script&lang=js"
import style0 from "./RangeColorLegend.vue?vue&type=style&index=0&id=202627f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202627f7",
  null
  
)

export default component.exports